export enum ChatRole {
  USER = "user",
  ASSISTANT = "assistant",
  SYSTEM = "system",
}

export type ChatMessage = {
  role: ChatRole;
  content: string;
  ts: number; // timestamp in milliseconds
};
export type fetchRecentMessagesRequest = {
  params: {
    clientId: string;
  };
};
export type fetchRecentMessagesResponse = ChatMessage[];

export type chatConnectedResponse = {
  coupon: {
    remainingSeconds: number;
  };
};

export type successLLMResponse = {
  character: string;
  member: string;
  response: string;
  intent: "normal" | "test";
};

export type successSTTResponse = {
  ok: boolean;
  text: string;
};
